import { useToast } from '@chakra-ui/react';

import { AuthLayout } from '../components/AuthLayout';
import { RegisterForm } from '../components/RegisterForm';

export const Register = () => {
  const toast = useToast();

  return (
    <AuthLayout title="Criar uma conta">
      <RegisterForm
        onSuccess={() =>
          toast({
            title: 'Conta criada com sucesso.',
            status: 'success',
            duration: 5000,
            isClosable: true,
          })
        }
      />
    </AuthLayout>
  );
};
